import { createAction } from '@reduxjs/toolkit'
import {
  type FetchCompanyAlarmsPayload,
  type FetchCompanyAlarmsSuccessPayload,
  type SetEnabledStatePayload
} from './settings-type'

/* Action Creators */

export const FetchCustomerAlarmsAction = createAction<FetchCompanyAlarmsPayload>('settings/fetchAlarms/request')
export const FetchCustomerAlarmsSuccessAction = createAction<FetchCompanyAlarmsSuccessPayload>('settings/fetchAlarms/success')
export const FetchCustomerAlarmsFailAction = createAction('settings/fetchAlarms/failure')
export const SaveCustomerAlarmsAction = createAction<FetchCompanyAlarmsSuccessPayload>('settings/saveAlarms/request')
export const SaveCustomerAlarmsSuccessAction = createAction<FetchCompanyAlarmsSuccessPayload>('settings/saveAlarms/success')

export const SetEmailEnabledAction = createAction<SetEnabledStatePayload>('settings/setEmailEnabled')
export const AddEmailRecipientAction = createAction<string>('settings/addEmailRecipient')
export const RemoveEmailRecipientAction = createAction<string>('settings/removeEmailRecipient')
export const ChangeEmailIntervalAction = createAction<number>('settings/changeEmailInterval')
export const SetSMSEnabledAction = createAction<SetEnabledStatePayload>('settings/setSmsEnabled')
export const SetTemperatureAlertsEnabledAction = createAction<SetEnabledStatePayload>('settings/setTemperatureAlertsEnabled')
export const UpdateTemperatureAlertLowerLimitAction = createAction<number>('settings/updateTemperatureAlertLowerLimit')
export const UpdateTemperatureAlertUpperLimitAction = createAction<number>('settings/updateTemperatureAlertsUpperLimit')
export const AddSMSRecipientAction = createAction<string>('settings/addSMSRecipient')
export const RemoveSMSRecipientAction = createAction<string>('settings/removeSMSRecipient')
export const UpdateSMSRecipientTextBoxAction = createAction<string>('settings/updateSmsRecipientTextBox')
export const ChangeSMSIntervalAction = createAction<number>('settings/changeSMSInterval')
